import { History } from "history";

import {
  GET_TRANSACTION_HISTORY,
  GET_TRANSACTION_HISTORY_ERROR,
  GET_TRANSACTION_HISTORY_SUCCESS,
  GET_TRANSACTION_HISTORY_V2,
  GET_TRANSACTION_HISTORY_V2_ERROR,
  GET_TRANSACTION_HISTORY_V2_SUCCESS,
  GetTransactionHistoryAction,
  GetTransactionHistoryErrorAction,
  GetTransactionHistorySuccessAction,
  GetTransactionHistoryV2Action,
  GetTransactionHistoryV2ErrorAction,
  GetTransactionHistoryV2SuccessAction,
} from "./actionTypes";
import {
  PaginateQuery,
  TransactionHistoryDto,
  TransactionHistoryV2Dto,
} from "../../interfaces";
import { Paginated } from "../../models";

//#region Get TransactionHistory

export const getTransactionHistory = (
  request: PaginateQuery,
  history: History
): GetTransactionHistoryAction => {
  return {
    type: GET_TRANSACTION_HISTORY,
    payload: { request, history },
  };
};

export const getTransactionHistorySuccess = (
  response: Paginated<TransactionHistoryDto>
): GetTransactionHistorySuccessAction => {
  return {
    type: GET_TRANSACTION_HISTORY_SUCCESS,
    payload: response,
  };
};

export const getTransactionHistoryError = (
  error: any
): GetTransactionHistoryErrorAction => {
  return {
    type: GET_TRANSACTION_HISTORY_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get TransactionHistory

export const getTransactionHistoryV2 = (
  request: PaginateQuery,
  history: History
): GetTransactionHistoryV2Action => {
  return {
    type: GET_TRANSACTION_HISTORY_V2,
    payload: { request, history },
  };
};

export const getTransactionHistoryV2Success = (
  response: Paginated<TransactionHistoryV2Dto>
): GetTransactionHistoryV2SuccessAction => {
  return {
    type: GET_TRANSACTION_HISTORY_V2_SUCCESS,
    payload: response,
  };
};

export const getTransactionHistoryV2Error = (
  error: any
): GetTransactionHistoryV2ErrorAction => {
  return {
    type: GET_TRANSACTION_HISTORY_V2_ERROR,
    payload: error,
  };
};

//#endregion
